import { render } from "./NotificationTable.vue?vue&type=template&id=392a2deb&ts=true"
import script from "./NotificationTable.vue?vue&type=script&lang=ts"
export * from "./NotificationTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__